// extracted by mini-css-extract-plugin
export default {"content":"styles_content__kjzrb","title":"styles_title__k3X1H","text":"styles_text__BOPSF"};